module.exports = __webpack_public_path__ + "static/media/005-Wechseln_ID_27.5dfb40a2.mp3";